import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import React, { useContext, useEffect, useState } from "react"
import { FlatList, RefreshControl, ScrollView, View } from "react-native"
import { ConstantLineChart } from "./ConstantsLineChart"
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native"
import { UserService } from "@Services/User.service"
import { ActivityIndicator, Card, Checkbox } from "react-native-paper"
import { baseColors, dimensions } from "@Constants/baseStyles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import CustomEmptyData from "@Components/CustomEmptyData"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ClientDateFormat } from "@Utils/utils"
import { Button } from "@Components/CustomButton/Button"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { ConstantsContext } from "@Providers/ConstantsProvider"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"

const ConstantCardDetails = () => {
    const navigation = useNavigation()
    const routes = useRoute()
    const { constantUnites } = useContext(ConstantsContext)
    const constant = routes?.params?.constant
    const constantId = constant?.id || 0
    const [fetching, setFetching] = useState(true)
    const [fetchingMainList, setFetchingMainList] = useState(true)
    const [deleting, setDeleting] = useState(false)
    const [updateData, setUpdateData] = useState(false)
    const [constantItems, setConstantItems] = useState([])
    const [contantData, setConstantData] = useState(null)
    const [constantToEdit, setConstantToEdit] = useState(null)
    const [selectedIds, setSelectedIds] = useState([])
    const user = useRecoilValue(userAtom)
    const userId = user?.id ?? 0
    const isFocused = useIsFocused()

    console.log({ constantUnites })

    const fetchConstants = () => {
        setFetchingMainList(true)
        UserService.getConstantsHistory(userId)
            .then((response) => {
                const dataRes = response?.data?.data
                const data = dataRes?.find((item) => item.id === constantId)
                setConstantData(data)
                setFetchingMainList(false)
            })
            .catch((e) => setFetchingMainList(false))
    }

    const handleFetchConstantById = () => {
        setFetching(true)
        UserService.GetConstantById(constantId)
            .then((response) => {
                const data = response?.data?.data
                const filtered = data?.filter((item) => item.userId === userId)
                console.log({ filtered })
                setConstantItems(filtered)
                setFetching(false)
            })
            .catch((error) => {
                console.log({ errorFetchingConstantById: error })
                setFetching(false)
            })
    }

    const hanleDeleteConstants = () => {
        setDeleting(true)
        UserService.DeleteConstantByIds(userId, selectedIds)
            .then(() => {
                ShowToast({
                    type: "success",
                    message: "Opération réussie."
                })
                setDeleting(false)
                setSelectedIds([])
                setUpdateData((prev) => !prev)
            })
            .catch((error) => {
                console.log({ errorDeletingConstant: error })
                ShowToast({
                    type: "error",
                    message: "Une erreur est survenue."
                })
                setDeleting(false)
            })
    }

    useEffect(() => {
        // if (constantId > 0) {
        fetchConstants()
        handleFetchConstantById()
        // }
    }, [constantId, updateData, isFocused])

    const handlePressCheckBox = (item) => {
        setConstantToEdit(item)
        let ids = new Set(selectedIds)

        if (ids.has(item.id)) {
            ids.delete(item.id)
        } else {
            ids.add(item.id)
        }

        setSelectedIds([...ids])
    }

    const handleEdit = () => {
        setSelectedIds([])
        navigation.navigate("ConstantFollowUpForm", {
            constantToEdit
        })
    }

    const showFooter = selectedIds?.length > 0
    const disableEditBtn = selectedIds?.length > 1

    const isEmpty = constantItems?.length === 0

    const constantUnit = constantUnites?.find((item) => item.id === constantId)

    const renderItem = ({ item }) => {
        return (
            <Card
                elevation={1}
                style={{
                    backgroundColor: "white",
                    margin: 5,
                    marginVertical: 10
                }}
                onPress={() => handlePressCheckBox(item)}
                contentStyle={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 10
                }}
            >
                <View>
                    <OpenSansText fontWeight="bold" fontSize={13}>
                        {ClientDateFormat(item.date)}
                    </OpenSansText>
                </View>

                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <OpenSansText fontSize={12}>
                        {item?.value} {constantUnit?.unit}
                    </OpenSansText>

                    <CustomCheckBox
                        checked={selectedIds?.includes(item.id)}
                        handleCheck={() => handlePressCheckBox(item)}
                        checkBoxColor={baseColors.orange.primary}
                    />
                </View>
            </Card>
        )
    }

    return (
        <ContainerStackScreen>
            <ScrollView>
                <View style={{ flex: 1 }}>
                    {fetchingMainList ? (
                        <View style={{ justifyContent: "center", alignItems: "center", marginVertical: 50 }}>
                            <ActivityIndicator color={baseColors.orange.primary} size={25} />
                            {/* <OpenSansText>Chargement en cours...</OpenSansText> */}
                        </View>
                    ) : contantData?.id > 0 ? (
                        <ConstantLineChart
                            constant={contantData}
                            // setConstantWithValues={setConstantWithValues}
                        />
                    ) : (
                        <CustomEmptyData />
                    )}
                </View>

                <View style={{ flex: 1, maxHeight: dimensions.fullHeight / 2 }}>
                    {fetching ? (
                        <View style={{ justifyContent: "center", alignItems: "center", marginVertical: 50 }}>
                            <OpenSansText>Chargement en cours...</OpenSansText>
                        </View>
                    ) : (
                        <FlatList
                            data={constantItems ?? []}
                            contentContainerStyle={{
                                paddingTop: 20,
                                paddingBottom: 150
                            }}
                            // ListEmptyComponent={<CustomEmptyData />}
                            showsVerticalScrollIndicator={false}
                            renderItem={renderItem}
                            keyExtractor={(item) => item.id.toString()}
                            refreshControl={
                                <RefreshControl refreshing={fetching} onRefresh={handleFetchConstantById} />
                            }
                        />
                    )}
                </View>
            </ScrollView>

            {showFooter && (
                <View
                    style={{
                        marginBottom: 10,
                        backgroundColor: "white",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Button
                        disabled={disableEditBtn || deleting}
                        onPress={handleEdit}
                        text="Editer"
                        width="40%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />

                    <Button
                        disabled={deleting}
                        loading={deleting}
                        onPress={hanleDeleteConstants}
                        text="Supprimer"
                        width="40%"
                        backgroundColor={baseColors.orange.primary}
                        labelColor={"white"}
                    />
                </View>
            )}
        </ContainerStackScreen>
    )
}

export default ConstantCardDetails
